/* =============================================================================
   T3BLOGG_OS — assets/desktop.js
   Window manager — drag, resize, focus, close. Auto-binds anything with .win.
   ============================================================================= */

(function () {
  'use strict';
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  let zTop = 10;

  function focusWin(w) { zTop += 1; w.style.zIndex = zTop; }

  function makeDraggable(win) {
    const bar = win.querySelector(':scope > .bar'); if (!bar) return;
    let dx = 0, dy = 0, ox = 0, oy = 0, dragging = false;
    bar.addEventListener('mousedown', e => {
      if (e.target.closest('button')) return;
      dragging = true; bar.classList.add('dragging');
      const rect = win.getBoundingClientRect();
      const parent = win.parentElement.getBoundingClientRect();
      ox = rect.left - parent.left;
      oy = rect.top - parent.top;
      dx = e.clientX; dy = e.clientY;
      focusWin(win);
      e.preventDefault();
    });
    document.addEventListener('mousemove', e => {
      if (!dragging) return;
      const parent = win.parentElement.getBoundingClientRect();
      let nx = ox + (e.clientX - dx);
      let ny = oy + (e.clientY - dy);
      nx = Math.max(-40, Math.min(parent.width - 60, nx));
      ny = Math.max(0, Math.min(parent.height - 30, ny));
      win.style.left = nx + 'px';
      win.style.top = ny + 'px';
      win.style.transform = 'none';
    });
    document.addEventListener('mouseup', () => { dragging = false; bar.classList.remove('dragging'); });
    win.addEventListener('mousedown', () => focusWin(win));
  }

  function makeResizable(win) {
    const handle = win.querySelector(':scope > .resize'); if (!handle) return;
    let sx, sy, sw, sh, resizing = false;
    handle.addEventListener('mousedown', e => {
      resizing = true; sx = e.clientX; sy = e.clientY;
      const r = win.getBoundingClientRect();
      sw = r.width; sh = r.height;
      e.preventDefault(); e.stopPropagation();
    });
    document.addEventListener('mousemove', e => {
      if (!resizing) return;
      win.style.width = Math.max(320, sw + (e.clientX - sx)) + 'px';
      win.style.height = Math.max(260, sh + (e.clientY - sy)) + 'px';
    });
    document.addEventListener('mouseup', () => { resizing = false; });
  }

  function bindWindow(el) {
    if (el.dataset.bound) return;
    el.dataset.bound = '1';
    if (el.dataset.noDrag !== '1')   makeDraggable(el);
    if (el.dataset.noResize !== '1') makeResizable(el);
    const closeBtn = el.querySelector(':scope > .bar .close');
    const minBtn = el.querySelector(':scope > .bar .min');
    if (closeBtn) closeBtn.addEventListener('click', e => {
      e.stopPropagation();
      // close action: 'navigate' (default for navigable), 'remove', or 'minimize' (default)
      const action = el.dataset.closeAction || (el.dataset.navigable === '1' ? 'navigate' : 'minimize');
      // If we pushed the URL on open, revert it before doing the close action.
      try {
        if (action !== 'navigate' && history.state && history.state.t3) {
          history.replaceState({}, '', '/');
        }
      } catch (err) {}
      if (action === 'navigate') {
        window.location.href = el.dataset.closeTarget || '/';
      } else if (action === 'remove') {
        el.remove();
      } else {
        el.classList.add('minimized');
      }
    });
    if (minBtn) minBtn.addEventListener('click', e => {
      e.stopPropagation();
      el.classList.toggle('minimized');
    });
  }

  function bindAll() {
    $$('.win').forEach(bindWindow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
  // Re-bind on section reloads in the customizer
  document.addEventListener('shopify:section:load', bindAll);

  window.T3Desktop = { bindWindow, bindAll, focusWin };
})();
